import React, { useCallback, useEffect, useState } from 'react';
import { Play, Sparkles, Crown } from 'lucide-react';
import { swrGet, sameData, resolveUrl } from '../lib/api';
import { t } from '../lib/i18n';
import StoryFeed from './StoryFeed';

const SEEN_KEY = 'dealgo_stories_seen';
const seen = () => { try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}'); } catch { return {}; } };

export const StoriesRow = () => {
  const [rows, setRows] = useState(() => swrGet('/stories').cached || []);
  const [open, setOpen] = useState(null);
  const [seenMap, setSeenMap] = useState(seen);
  useEffect(() => { swrGet('/stories').promise.then((d) => setRows((p) => (sameData(p, d) ? p : d || []))).catch(() => {}); }, []);
  const markSeen = useCallback((brandId) => {
    setSeenMap((m) => { const b = rows.find((x) => x.brand_id === brandId); if (!b) return m; const next = { ...m, [brandId]: b.videos.map((v) => v.id).join(',') }; localStorage.setItem(SEEN_KEY, JSON.stringify(next)); return next; });
  }, [rows]);
  if (!rows.length) return null;
  const openBrand = (b) => { markSeen(b.brand_id); setOpen(b.brand_id); };
  return (
    <section className="mb-8" data-testid="stories-row" aria-label={t('Stories de la semaine')}>
      <div className="flex items-center gap-2 mb-3 px-1">
        <Play size={14} className="text-[#E50914]" fill="currentColor" />
        <h2 className="text-base md:text-lg font-bold text-white light:text-black">{t('Stories de la semaine')}</h2>
        <span className="text-[10px] font-bold uppercase tracking-widest text-[#808080]">{t('Clips produits de 15 secondes')}</span>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-none snap-x">
        {rows.map((b, i) => {
          const unseen = seenMap[b.brand_id] !== b.videos.map((v) => v.id).join(',');
          return (
            <button key={b.brand_id} type="button" onClick={() => openBrand(b)} className="group flex flex-col items-center gap-2 w-[76px] shrink-0 snap-start" data-testid={`story-brand-${b.slug || b.brand_id}`} style={{ animationDelay: `${i * 60}ms` }}>
              <span className={`relative w-[68px] h-[68px] rounded-full p-[3px] transition-transform group-hover:scale-105 ${unseen ? '' : 'bg-[#3a3a3a]'}`} data-testid="story-ring" data-unseen={unseen}>
                {unseen && <span className="story-ring" aria-hidden><span /></span>}
                <span className="relative block w-full h-full rounded-full bg-[#141414] p-[3px]">
                  <span className="block w-full h-full rounded-full bg-white overflow-hidden flex items-center justify-center">
                    {b.logo ? <img src={resolveUrl(b.logo)} alt={b.brand} className="w-full h-full object-contain p-1.5" loading="lazy" /> : <span className="text-black font-black">{b.brand[0]}</span>}
                  </span>
                </span>
                <span className="absolute -bottom-0.5 -right-0.5 w-6 h-6 rounded-full bg-[#E50914] text-white border-2 border-[#141414] flex items-center justify-center"><Play size={10} fill="currentColor" /></span>
                {b.event ? <span className="absolute -bottom-1 inset-x-0 mx-auto w-fit px-1.5 py-px rounded-full bg-[#E50914] text-white text-[8px] font-black uppercase tracking-wider border-2 border-[#141414] inline-flex items-center gap-0.5 live-badge-glow" data-testid="story-event-badge"><Crown size={8} /> Live</span> : b.sponsored && <span className="absolute -top-1 -left-1 w-5 h-5 rounded-full bg-[#f5c451] text-black border-2 border-[#141414] flex items-center justify-center" title={t('Sponsorisé')} data-testid="story-sponsored"><Sparkles size={10} /></span>}
              </span>
              <span className="text-[11px] font-semibold text-[#B3B3B3] group-hover:text-white truncate w-full text-center">{b.brand}</span>
            </button>
          );
        })}
      </div>
      {open && <StoryFeed rows={rows} startBrandId={open} onClose={() => setOpen(null)} onBrandSeen={markSeen} />}
    </section>
  );
};

export default StoriesRow;
